export const calculateTaxRowValue = (data, taxes, watchTax) => {
    const taxRate = data.taxObjId && taxes
        ? (taxes.find(t => t.id === data.taxObjId)?.value ?? 0)
        : 0;

    if (taxRate <= 0) return 0;

    const count = data.count || 0;
    const discount = data.discount || 0;

    let discounted;

    if (data.changeSumm) {
        // summ уже содержит скидку — НЕ применяем её повторно
        discounted = parseFloat(data.summ || 0);
    } else {
        // приоритет clientPrice (актуальная цена), price — только fallback
        const price = data.clientPrice || data.price || 0;
        const gross = price * count;
        discounted = gross * (1 - discount / 100);
    }

    let tax = 0;

    if (watchTax?.id === 0) {
        tax = discounted * (taxRate / (100 + taxRate));
    } else if (watchTax?.id === 1) {
        tax = discounted * (taxRate / 100);
    }

    return parseFloat(tax.toFixed(2));
};